var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isGranted('VIEW_SUBSCRIPTIONS'))?_c('user-subscriptions-table',{ref:"userSubscriptionsTable",attrs:{"user-id":_vm.userId}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }